export default __webpack_public_path__ + "static/media/certificate-example.96db1229.png";